import { render } from "./DotVertical.vue?vue&type=template&id=18394714&scoped=true"
const script = {}

import "./DotVertical.vue?vue&type=style&index=0&id=18394714&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18394714"]])

export default __exports__